import {gsap} from "../utils/vendor.js";

/**
 * Slider per la gestione delle testimonianze.
 *
 * Se dovesse servire, è abbastanza facile estrarre il codice specifico per le testimonianze e creare
 * varie classi che estendono questa per gestire vari tipologie di slide.
 */
class Slider {
    defaultOptions = {
        slidesSelector: ".slide",
        nextSelector: ".next",
        prevSelector: ".prev",
        autoPlay: true,
        autoPlayPause: 5, // seconds
    };

    constructor(container, options) {
        this.container = container;
        this.options = Object.assign({}, this.defaultOptions, options);

        this.slides = container.querySelectorAll(this.options.slidesSelector);
        this.next = container.querySelector(this.options.nextSelector);
        this.prev = container.querySelector(this.options.prevSelector);

        this.currentSlide = 1;
        this.animating = false;

        // Se c'è una sola slide, nascondo i tasti prev/next ed esco.
        if (this.slides.length <= 1) {
            if (this.next) {
                this.next.style.display = "none";
            }

            if (this.prev) {
                this.prev.style.display = "none";
            }

            return;
        }

        this.bindEvents();

        if (this.options.autoPlay) {
            this.waitAndNext();
        }
    }

    bindEvents() {
        this.next?.addEventListener("click", () => this.changeSlide("next"));
        this.prev?.addEventListener("click", () => this.changeSlide("prev"));
    }

    changeSlide(direction) {
        if (this.animating) {
            return;
        }

        let from = this.currentSlide;

        if ("next" === direction) {
            this.currentSlide = this.currentSlide >= this.slides.length ? 1 : this.currentSlide + 1;
        } else {
            this.currentSlide = this.currentSlide <= 1 ? this.slides.length : this.currentSlide - 1;
        }

        this.animateSlide(this.slides[from - 1], this.slides[this.currentSlide - 1], direction);
    }

    waitAndNext() {
        if (this.autoPlayTimeout) {
            clearTimeout(this.autoPlayTimeout);
        }

        this.autoPlayTimeout = setTimeout(
            () => {
                this.changeSlide("next")
            },
            this.options.autoPlayPause * 1000
        );
    }

    /**
     * Questo metodo può essere sovrascritto per personalizzare l’animazione della slide.
     */
    animateSlide(from, to, direction) {
        this.animating = true;
        let directionCoefficient = direction === "next" ? 1 : -1;

        gsap.timeline()
            .set(
                to,
                {
                    opacity: 1
                }
            )
            .fromTo(
                from.children,
                {
                    opacity: 1
                },
                {
                    opacity: 0,
                    y: 20 * directionCoefficient,
                    ease: "expo.in",
                    stagger: 0.1,
                    duration: 0.3
                }
            )
            .fromTo(
                to.children,
                {
                    opacity: 0,
                    y: -20 * directionCoefficient
                },
                {
                    opacity: 1,
                    y: 0,
                    ease: "power3.out",
                    stagger: 0.1,
                    onComplete: () => {
                        this.animating = false;

                        if (this.options.autoPlay) {
                            this.waitAndNext();
                        }
                    }
                },
                "+=0.1"
            )
        ;
    }
}

export default class TestimonialComponent {
    init() {
        document.querySelectorAll(".js-testimonial").forEach(slider => {
            new Slider(slider, {
                slidesSelector: ".js-testimonial-item",
                nextSelector: ".js-testimonial-next",
                prevSelector: ".js-testimonial-prev",
            });
        });
    }
}
